import { TextField } from "@mui/material";
import { ButtonGroupSelector } from "features/WorklistTools/shared/components/ButtonGroupSelector";
import { CommaNumberInput } from "features/WorklistTools/shared/components/CommaNumberInput";
import { ApplyCellNumOption } from "features/WorklistTools/shared/interfaces";
import React, { useState } from "react";
import { DestPlateInfoState } from "../state";

interface WellMappingTableHeaderProps {
  handleApplyCellNumber: (
    option: string | number,
    cellNumber: number | undefined
  ) => void;
  destPlates?: DestPlateInfoState[];
}

export const WellMappingTableHeader = ({
  handleApplyCellNumber,
  destPlates,
}: WellMappingTableHeaderProps) => {
  const [cellNumber, setCellNumber] = useState<number | undefined>();

  const additionalOptions: ApplyCellNumOption[] =
    (destPlates &&
      destPlates
        .filter((destPlate) => destPlate.plateBarcode !== "")
        .map((destPlate) => ({
          label: destPlate.plateBarcode,
          value: destPlate.index,
        }))) ??
    [];

  return (
    <React.Fragment>
      <TextField
        value={cellNumber ?? ""}
        onChange={(e) => setCellNumber(Number(e.target.value))}
        size="small"
        InputProps={{
          inputComponent: CommaNumberInput as any,
        }}
        label="Cell Number"
      />
      <ButtonGroupSelector
        handleApplyCellNumber={handleApplyCellNumber}
        cellNumber={cellNumber}
        additionalOptions={additionalOptions}
      />
    </React.Fragment>
  );
};
